<template>
    <div
        class="primary-filters-container main"
        :class="{ 'docked': isDocked, 'active': ! isLoading }"
    >
        <div class="primary-filters default">

            <div
                class="primary-filter destination input-suggest"
                :class="{ 'active': this.activeFilter === 'destination' && isDocked }"
                @click="handleToggleDestinationFilter()"
            >
                <template v-if="isOnMobile">

                    <div v-if="titles.destination.country === null">
                        {{ filtersDestination.country.translations.title }}
                    </div>

                    <span class="truncate" v-else>

                    <span v-if="titles.destination.provinceRegion === null">
                        {{ titles.destination.country  }}
                    </span>
                    <span v-else>
                    <img
                         class="inline-block w-5 rounded-sm mr-2 mb-2"
                         :src="'/assets/img/frontend-v3/flags/' + getLocale(titles.destination.country) + '.svg'"
                         :alt="getLocale(titles.destination.country)"
                     >
                    </span>

                    <span v-if="titles.destination.provinceRegion">
                         {{ getShortDestinationString(this.titles.destination.provinceRegion) }}
                    </span>

                    <span v-if="titles.destination.place">
                        | {{ getShortDestinationString(this.titles.destination.place) }}
                    </span>
                </span>

                </template>

                <div class="w-full" v-show="! isOnMobile">
                    <filter-input-suggest
                        :filter-data="filtersDestination"
                        :context="suggestContext"
                    ></filter-input-suggest>
                </div>

            </div>
            <div
                class="primary-filter arrival"
                :class="{ 'active': this.activeFilter === 'arrival' && isDocked }"
                @click="toggleFilter('arrival')"
            >
                <span class="truncate">
                    {{ this.titles.arrivalAndStay }}
                </span>
            </div>

            <div
                class="primary-filter companions"
                :class="{ 'active': this.activeFilter === 'companions' && isDocked }"
                @click="toggleFilter('companions')"
            >
                <span class="truncate">
                    {{ titles.companions }}
                </span>
            </div>

            <a
                v-if="showSearchButton"
                class="to-overview primary-search-button flex-shrink-0 button orange-700 py-4 xl:py-0 justify-center select-none !h-full !pl-12 !pr-20 rounded lg:rounded-r-full cta"
                :class="{ 'pointer-events-none opacity-50' : ! enabledOverviewButton }"
                :href="url"
            >
                {{ translations.search }}
            </a>
        </div>
    </div>

    <div
        class="primary-filters-main"
        :class="{ 'active': isActive && isDocked }"
    >
        <swiper
            ref="swiper"
            class="swiper basic z-10 transition duration-300"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :slides-per-view="1"
            :space-between="16"
            :allow-touch-move="false"
            :loop="false"
        >
            <swiper-slide class="swiper-slide swiper-slide-primary-filter">
                <div
                    class="primary-filter-overlay"
                    :class="{ 'active': this.activeFilter === 'destination' }"
                >
                    <div class="primary-filter-main max-w-5xl">
                        <div class="primary-filter-header-main">
                            <div class="primary-filter-header">
                                <div class="primary-filter-header-text">

                                    {{ getShortDestinationString(this.titles.destination.country ?? filtersDestination.country.translations.title) }}
                                    <template v-if="this.titles.destination.provinceRegion">
                                        | {{ getShortDestinationString(this.titles.destination.provinceRegion) }}
                                    </template>
                                    <template v-if="this.titles.destination.place">
                                        | {{ getShortDestinationString(this.titles.destination.place) }}
                                    </template>

                                </div>
                                <button class="primary-filter-close" aria-label="close" @click.prevent="close">&nbsp;</button>
                            </div>
                        </div>
                        <div class="primary-filter-content">

                            <filter-destination
                                :filter-data="filtersDestination"
                                :translations="translations"
                                :suggestContext="suggestContext"
                            ></filter-destination>

                        </div>

                        <div class="primary-filter-footer relative">

                            <div class="absolute bottom-14 left-0 w-full p-2 px-4 bg-hh-cyan-300 border-4 border-b0 border-hh-grey-50 rounded cursor-pointer xl:hover:bg-hh-cyan-200 z-100"
                                 @click="togglePlaces"
                                 v-if="filtersDestination?.place && (showPlaces || filtersDestination['province-region'])"
                            >
                                <template v-if="arePlacesActive">
                                    {{ filtersDestination?.country.translations['select-prov-reg'] }}
                                </template>
                                <template v-else>
                                    {{ filtersDestination?.country.translations['select-place'] }}
                                </template>
                            </div>

                            <button
                                v-if="hasDestination()"
                                class="button md cyan-clear rounded-lg mr-3 px-12"
                                @click.prevent="clearAll('destination')"
                            >
                                {{ translations['clear'] }}
                            </button>

                            <button
                                class="button md cta rounded md:rounded-br-3xl lg-max:w-1/2"
                                @click.prevent="checkAndActivateFilter('arrival')"
                            >{{ hasArrival() ? translations['save'] : translations['continue'] }}</button>
                        </div>
                    </div>
                </div>
            </swiper-slide>

            <swiper-slide class="swiper-slide swiper-slide-primary-filter filter-arrival">

                <div class="primary-filter-overlay" :class="{ 'active': this.activeFilter === 'arrival' }">
                    <div class="primary-filter-main max-w-5xl">
                        <div class="primary-filter-header-main">
                            <div class="primary-filter-header">
                                <div class="primary-filter-header-text">
                                    {{ this.titles.arrivalAndStay }}
                                </div>
                                <button class="primary-filter-close" aria-label="close" @click.prevent="close">&nbsp;</button>
                            </div>
                        </div>
                        <div class="primary-filter-content">

                            <filter-arrival-and-stay
                                :filter-data="filtersArrivalAndStay"
                                :filter-data-los="filtersLos"
                                :options="{ showFlexibleDates: this.showFlexibleDates }"
                            ></filter-arrival-and-stay>

                        </div>
                        <div class="primary-filter-footer">
                            <button
                                v-if="hasArrival()"
                                class="button md cyan-clear rounded-lg mr-3 px-12"
                                @click.prevent="clearAll('arrival')"
                            >
                                {{ translations['clear'] }}
                            </button>

                            <button
                                class="button md cta rounded md:rounded-br-3xl lg-max:w-1/2"
                                @click.prevent="checkAndActivateFilter('companions')"
                            >{{ hasCompanions() ? translations['save'] : translations['continue'] }}</button>
                        </div>
                    </div>
                </div>

            </swiper-slide>

            <swiper-slide class="swiper-slide swiper-slide-primary-filter">

                <div class="primary-filter-overlay" :class="{ 'active': this.activeFilter === 'companions' }">
                    <div class="primary-filter-main max-w-2xl">
                        <div class="primary-filter-header-main">
                            <div class="primary-filter-header">
                                <div class="primary-filter-header-text">
                                    {{ filtersCompanions.title }}
                                </div>
                                <button class="primary-filter-close" aria-label="close" @click.prevent="close">&nbsp;</button>
                            </div>
                        </div>
                        <div class="primary-filter-content px-4 !bg-hh-cyan-100">

                            <filter-companions
                                :filter-data="filtersCompanions"
                            ></filter-companions>

                        </div>
                        <div class="primary-filter-footer">
                            <button
                                v-if="hasCompanions()"
                                class="button md cyan-clear lg:px-12 rounded-lg px-0 justify-center mr-3 lg-max:w-1/3"
                                @click.prevent="clearAll('companions')"
                            >
                                {{ translations['clear'] }}
                            </button>

                            <a
                                v-if="showSearchButtonOnLastFilter"
                                class="to-overview truncate button pr-12 md cta rounded md:rounded-br-3xl lg-max:w-2/3"
                                :class="{ 'pointer-events-none opacity-50' : ! enabledOverviewButton }"
                                :href="url"
                            >{{ translations['show-holiday-homes'] }}</a>

                            <button
                                v-else
                                class="button md cta rounded md:rounded-br-3xl lg-max:w-1/2"
                                @click.prevent="closeAndEmit"
                            >{{ translations['save'] }}</button>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>

import {Swiper, SwiperSlide} from "swiper/vue";
import ScrollsToTarget from "../../../Mixins/ScrollsToTarget.js";
import HandlesConvertTests from "@/assets/js/frontend-v3/website/Mixins/Tests/HandlesConvertTests.js";

export default {

    name: "PrimaryFilters",

    components: {Swiper, SwiperSlide},

    mixins: [ScrollsToTarget, HandlesConvertTests],

    props: [
        'page-type',
        'prefix',
        'filter-data-destination',
        'filter-data-arrival-and-stay',
        'filter-data-los',
        'filter-data-companions',
        'filter-url',
        'with-search-button',
        'with-search-button-on-last-filter',
        'with-flexible-dates',
        'with-input-suggest',
        'translations',
        'ip-valid'
    ],

    data() {
        return {

            activeFilter: null,
            isLoading: true,
            isDocked: false,
            showSearchButton: false,
            showFlexibleDates: false,
            showSearchButtonOnLastFilter: false,
            enabledOverviewButton: true,
            suggestContext: null,

            filtersArrivalAndStay: {},
            filtersLos: {},
            filtersDestination: {},
            filtersCompanions: {},

            url: '/',

            swiper: null,
            slideSpeed: 500,

            showPlaces: false,
            arePlacesActive: false,

            titles: {
                destination: {
                    country: null,
                    provinceRegion: null,
                    place: null,
                },
                arrivalAndStay: null,
                companions: null,
            },
        }
    },

    created() {

        this.filtersDestination = this.filterDataDestination;
        this.filtersArrivalAndStay = this.filterDataArrivalAndStay;
        this.filtersLos = this.filterDataLos;
        this.filtersCompanions = this.filterDataCompanions;
        this.url = this.filterUrl;
        this.showSearchButton = this.withSearchButton ?? this.showSearchButton;
        this.showSearchButtonOnLastFilter = this.withSearchButtonOnLastFilter ?? this.showSearchButtonOnLastFilter;
        this.showFlexibleDates = this.withFlexibleDates ?? this.showFlexibleDates;
        this.suggestContext = this.showSearchButton ? 'homepage' : 'overview';

        this.initTitles();

        //A/B test
        this.isIpValid = this.ipValid !== undefined && this.ipValid === 1;

        if (this.isIpValid) {
            this.setVariation('destination', 'B')
        } else {
            this.determineVariation('destination');
        }
    },

    mounted() {

        this.Bus.on('update-filters', (data) => {

            this.filtersDestination = data.destination.filters;
            this.filtersCompanions = data.companions.filters.companions;
            this.filtersArrivalAndStay = data['arrival-and-stay'].filters['arrival-day'];
            this.filtersLos = data['arrival-and-stay'].filters['length-of-stay'];

            this.enabledOverviewButton = true;

            this.$nextTick(() => {
                this.initTitles();
            })
        });

        this.Bus.on('close-filters', (data) => {
            this.close();
        });

        this.Bus.on('filter-segments-changed', (segments) => {
            this.url = this.prefix + '/' + segments;
        });

        this.Bus.on('activate-filter-external', (reference) => {
            this.activateFilter(reference);
        });

        this.Bus.on('deactivate-filter-external', (reference) => {
            this.deactivateFilter(reference);
        });

        this.Bus.on('check-and-activate-filter-external', (reference) => {
            this.checkAndActivateFilter(reference);
        });

        this.Bus.on('toggle-places', (value) => {
            this.showPlaces = value;
            this.arePlacesActive = value;
        });

        this.Bus.on('set-places-active', (value) => {
            this.showPlaces = value;
            this.arePlacesActive = value;
        });

        this.Bus.on('companion-touched', (value) => {
            this.enabledOverviewButton = false;
        });

        this.Bus.on('show-destination', (reference) => {
            this.showPlaces = true;
        });

        this.Bus.on('hide-destination', (reference) => {
            this.showPlaces = false;
        });

        this.isLoading = false;

        window.addEventListener('scroll', this.triggerUpdate, supportsPassive() ? { passive: true } : false);
        this.triggerUpdate();

        document.body.addEventListener('keydown', this.handleKeyDown);
    },

    methods: {

        triggerUpdate(event){

            if (! this.isOnMobile) {

                let stickyTarget = document.getElementById('primary-filters-target');
                let rectStickyTarget = stickyTarget.getBoundingClientRect();
                this.isDocked = rectStickyTarget.top <= 4;

                if (! this.isDocked) {
                    this.close();
                }
            }
        },

        onSwiper(swiper) {
            this.swiper = swiper;
        },

        onSlideChange() {
            if (this.swiper.activeIndex === 1) {
                this.$nextTick(() => {
                    // this.Bus.emit('activate-filter', 'arrival');
                });
            }
        },

        toggleFilter(reference) {

            if (this.activeFilter === null || this.activeFilter !== reference) {
                document.addEventListener('click', this.closeOnClickOutside);
                this.activateFilter(reference);
            }  else {
                document.removeEventListener('click', this.closeOnClickOutside);
                this.close();
            }
        },

        closeOnClickOutside(event) {

            if (
                event.target.classList.contains('swiper-slide-primary-filter')
                || event.target.classList.contains('primary-filters-container')
                || event.target.classList.contains('primary-filter-overlay')
            ) {
                this.close();
            }
        },

        close() {
            this.activeFilter = null;

            if (document.documentElement.classList.contains('popup-active')) {
                this.Bus.emit('set-popup-inactive-class');
            }

            this.Bus.emit('dock-header');

            document.removeEventListener('click', this.closeOnClickOutside);
        },

        closeAndEmit() {
            this.close();
            this.Bus.emit('close-primary-filters');
        },

        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.close();
            }
        },

        checkAndActivateFilter(reference) {

            if (reference === 'arrival' && this.hasArrival()) {
                this.close();
                return
            }

            if (reference === 'companions' && this.hasCompanions()) {
                this.close();
                return;
            }

            this.activateFilter(reference);
        },

        activateFilter(reference) {

            this.Bus.emit('set-popup-active-class');

            this.$nextTick(() => {
                document.addEventListener('click', this.closeOnClickOutside);
            })

            const slideSpeed = (this.activeFilter === null)
                ? 0
                : this.slideSpeed;

            let delay = 500;

            if (this.isOnMobile) {
                this.isDocked = true;
                this.activateFilterAndEmit(reference);

            } else {
                if (! this.isDocked) {
                    let targetTop = document.getElementById('primary-filters-target').offsetTop;
                    this.scrollTo(targetTop, delay);
                } else {
                    delay = 50;
                }

                setTimeout(() => {
                    this.activateFilterAndEmit(reference)

                    this.Bus.emit('set-popup-active-class');

                    this.$nextTick(() => {
                        document.addEventListener('click', this.closeOnClickOutside);
                    })

                }, delay);
            }

            const primaryFilters = Array.from(document.querySelectorAll('.primary-filter'));
            const index = primaryFilters.findIndex(filter => filter.classList.contains(reference));

            this.swiper.slideTo(index, slideSpeed);

            //NEW! load initial country counts because we no longer do an initial ES query on every load
            if (reference === 'destination' && ! this.isOnMobile) {
                this.Bus.emit('filter-change', '');
            }
        },

        deactivateFilter(reference) {
            if (this.activeFilter === reference) {
                this.close();
            }
        },

        activateFilterAndEmit(reference) {
            this.activeFilter = reference;
            this.Bus.emit('activate-filter', reference);
        },

        initTitles() {

            //destination
            let titleCountry = this.filtersDestination['country']?.title ?? null;
            let titleCountryDefault = this.filtersDestination['country']?.defaultTitle ?? null;

            this.titles.destination.country = titleCountry !== titleCountryDefault ? titleCountry : null;

            let titleProvReg = this.filtersDestination['province-region']?.title ?? null;
            let titleProvRegDefault = this.filtersDestination['province-region']?.defaultTitle ?? null;

            this.titles.destination.provinceRegion = titleProvReg !== titleProvRegDefault ? titleProvReg : null;

            let titlePlace = this.filtersDestination['place']?.title ?? null;
            let titlePlaceDefault = this.filtersDestination['place']?.defaultTitle ?? null;

            this.titles.destination.place = titlePlace !== titlePlaceDefault ? titlePlace : null;

            //arrival and stay
            this.titles.arrivalAndStay = this.getArrivalAndStayTitle();

            //companions
            this.titles.companions = this.filtersCompanions.title;
        },

        getLocale(title) {
            return this.filtersDestination.country.options.flags[title];
        },

        getShortDestinationString(string) {
            const split = (string === null ? '' : string).split(', ');
            return split.length === 1 ? string : split[0] + ' (+' + (split.length - 1) + ')';
        },

        getArrivalAndStayTitle() {

            const selectedDates = this.filtersArrivalAndStay.items.selectedDates;

            if (! selectedDates.start) {
                return this.filtersArrivalAndStay.title;
            }

            let returnDate = selectedDates.start.dateFormatted;

            if (selectedDates.end?.dateFormatted) {
                returnDate += ' → ' + selectedDates.end.dateFormatted;
            }

            return returnDate;
        },

        clearAll(reference) {
            this.Bus.emit('clear-primary-filter', reference);
        },

        hasDestination() {
            return Object.values(this.filtersDestination?.country?.selectedFilters ?? {}).length > 0;
        },

        hasArrival() {
            return Object.values(this.filtersArrivalAndStay.selectedFilters ?? {}).length > 0;
        },

        hasCompanions() {
            return Object.values(this.filtersCompanions.selectedFilters ?? {}).length > 0;
        },

        togglePlaces() {
            this.arePlacesActive = ! this.arePlacesActive;

            this.Bus.emit('toggle-places', this.arePlacesActive);
        },

        handleToggleDestinationFilter() {
            if (this.isOnMobile) {
                this.toggleFilter('destination');
            }
        }
    },

    computed: {

        isOnMobile() {
            return window.innerWidth <= 1024;
        },

        isActive() {
            return this.activeFilter !== null;
        },
    },
}
</script>
